// @flow
import type { CustomerSignupFormValues } from '../customer-signup';

export const createCustomerSignup = (
  values: CustomerSignupFormValues,
  apiUrl: string,
): Promise<Response> =>
  fetch(`${apiUrl.toString()}integrations/customer_signup`, {
    method: 'POST',
    body: JSON.stringify(values),
    headers: {
      'Content-Type': 'application/json',
    },
  });
